import moment from 'moment'
import React from 'react'
import styled, { css } from 'styled-components'

import angleLeft from '../../images/message_angle_left.png'
import angleRight from '../../images/message_angle_right.png'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { getCurrentServerUrl } from '../../helpers/axios'

const StyledMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: ${(props) => (props.side === 'left' ? 'flex-start' : 'flex-end')};
  margin-bottom: 20px;
  width: 90%;

  word-wrap: break-word;
`

const StyledMessageInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.side === 'left' ? 'flex-start' : 'flex-end'};
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;

  margin-bottom: 10px;

  .author {
    text-transform: uppercase;
    color: #8097b1;
    font-size: 11px;
    letter-spacing: 1.12px;
    margin-right: 10px;
  }

  .date {
    color: #b0bac9;
    font-size: 10px;
    letter-spacing: 2.2px;
  }
`

const StyledMessage = styled.div`
  position: relative;
  padding: 16px 16px 20px 16px;

  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: normal;

  ${(props) =>
    props.side === 'left' &&
    css`
      border: 1px solid #ececf0;
      border-radius: 17px 17px 17px 0;
      background-color: #f9f9f9;

      color: #2e384d;

      ::after {
        content: ' ';
        position: absolute;
        bottom: -7px;
        left: -1px;
        height: 8px;
        width: 8px;
        background: url(${angleLeft}) no-repeat center center;
      }
    `}

  ${(props) =>
    props.side === 'right' &&
    css`
      border-radius: 17px 17px 0 17px;
      background-color: #2e5bff;

      color: #ffffff;

      ::after {
        content: ' ';
        position: absolute;
        bottom: -7px;
        right: 0px;
        height: 8px;
        width: 8px;
        background: url(${angleRight}) no-repeat center center;
      }
    `}
`

const StyledFilesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: ${(props) => (props.side === 'left' ? 'flex-start' : 'flex-end')};
  margin-bottom: 20px;
`

const StyledFileItem = styled.a`
  display: flex;
  align-items: center;
  margin-right: 15px;
  transition: opacity 0.2s;

  color: ${(props) => (props.side === 'left' ? '#2e384d' : '#fff')};

  :hover {
    color: ${(props) => (props.side === 'left' ? '#2e384d' : '#fff')};
    opacity: 0.8;
  }

  .iconContainer {
    margin-right: 10px;
  }

  .file_name {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    font-size: 13px;
  }
`

export default ({ event }) => {
  const { direction, attachments, author, date, text } = event

  const side = direction === 'IN' ? 'right' : 'left'

  return (
    <React.Fragment>
      <StyledMessageWrapper side={side}>
        <StyledMessageInfo side={side}>
          <div className="author">{author}</div>
          <div className="date">{moment(date).format('DD/MM/YY - HH:mm')}</div>
        </StyledMessageInfo>
        <StyledMessage side={side} dangerouslySetInnerHTML={{ __html: text }} />
      </StyledMessageWrapper>
      {attachments.length > 0 && (
        <StyledFilesWrapper side={side}>
          <StyledMessage side={side}>
            {attachments.map(({ url, thumbnail, name }) => {
              return (
                <StyledFileItem
                  side={side}
                  href={`${url}`}
                  download={name}
                  target="_blank"
                  thumbUrl={thumbnail}
                  title={name}
                  key={url}
                >
                  <div className="iconContainer">
                    <FontAwesomeIcon size="1x" icon="file-download" />
                  </div>
                  <div className="file_name">{name}</div>
                </StyledFileItem>
              )
            })}
          </StyledMessage>
        </StyledFilesWrapper>
      )}
    </React.Fragment>
  )
}
